export const IconAiSparkle = (props: { onMouseEnter?: () => void; onMouseLeave?: () => void }) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26 13C26 20.1797 20.1797 26 13 26C5.82029 26 0 20.1797 0 13C0 5.8203 5.82029 3.8147e-06 13 3.8147e-06C20.1797 3.8147e-06 26 5.8203 26 13Z"
        fill="black"
      />
      <path
        d="M13.4 5.9C14.4 12 14.4 12 19.7 13C14.4 14 14.4 14 13.4 20.1C12.4 14 12.4 14 7.1 13C12.4 12 12.4 12 13.4 5.9Z"
        stroke="white"
        strokeWidth="1"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M19 6.45C19.3 8.5 19.3 8.5 21.35 8.8C19.3 9.1 19.3 9.1 19 11.15C18.7 9.1 18.7 9.1 16.65 8.8C18.7 8.5 18.7 8.5 19 6.45Z"
        fill="white"
      />
      <path
        d="M8.4 15.32C8.62 16.78 8.62 16.78 10.08 17C8.62 17.22 8.62 17.22 8.4 18.68C8.18 17.22 8.18 17.22 6.72 17C8.18 16.78 8.18 16.78 8.4 15.32Z"
        fill="white"
      />
    </svg>
  )
}
